<template>
  <div class="p-3 pt-md-4 pt-5 text-white">
    <v-container fluid>
      <v-row>
        <v-col md="3">
          <MarkerComponent
            :active-tab="-1"
            :challenge="challenge"
          />
        </v-col>
        <v-col md="9">
          <p class="text-white">
            Após marcar o botão de conclusão desta prova, você não poderá
            voltar para alterar respostas ou conferir alguma marcação.
            Certifique-se que respondeu TODAS as questões antes de dar o
            próximo passo.
          </p>
          <p class="text-white">
            Lembre-se: o resultado completo poderá ser visto imediatamente
            após a conclusão da prova ou após o fim do ciclo, de acordo com a
            definição da sua escola.
          </p>
          <div
            id="confirm-button-container"
            class="mt-4 d-flex justify-content-between justify-content-md-end flex-wrap"
          >
            <v-btn
              rounded
              outlined
              class="border-challenge mr-3 text-white mt-4"
              @click="isFinishing = false"
            >
              <i class="fas fa-solid fa-reply mr-1" /> Voltar para o desafio
            </v-btn>
            <v-btn
              rounded
              color="challenge"
              class="text-white font-weight-bold mt-4"
              @click="end()"
            >
              Finalizar desafio
              <v-icon
                right
                dark
              >
                fas fa-solid fa-check-circle
              </v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex'
import MarkerComponent from "@/common/components/challenge/MarkerComponent.vue";

export default {
  components : {
    MarkerComponent,
  },
  computed : {
    ...mapState({
      challenge : state => state.challenge.current
    }),
    isFinishing: {
      get() {
        return this.$store.state.challenge.isFinishingCurrentChallenge;
      },
      set(value) {
        this.$store.commit('SET_IS_FINISH_CURRENT_CHALLENGE', value);
      },
    },
  },
  methods: {
    ...mapActions([
      'finishChallenge',
      'getCycles'
    ]),
    end() {
      const data = {id: this.challenge.id };
      this.finishChallenge(data)
      .then(({ data : {data : challenge} }) => {
        this.$emit('onClose')
        this.isFinishing = false;
        this.$notify({
            type: 'success',
            title: 'Sucesso',
            text: 'Desafio finalizado com sucesso.'
          })
        this.getCycles();
      });
    },
  }
}
</script>
<style scoped>
  @media screen and (max-width: 766px) {
    #confirm-button-container button{
      width: 100%;
    }
  }
</style>

